export default "__VITE_ASSET__cd4ca060__"